import { Label } from '@/types/workflow-types';
import { apiRequest } from '@/utils/api-request';

interface CreateLabelRequest {
  name: string;
  description?: string;
  color?: string;
}

interface CreateLabelResponse {
  data?: Label;
  detail?: string;
}

export async function createLabel(
  orgId: string,
  data: CreateLabelRequest,
): Promise<CreateLabelResponse> {
  const response = await apiRequest<CreateLabelResponse>({
    url: `/api/v1/orgs/${orgId}/labels`,
    target: 'workflow',
    method: 'POST',
    body: data as unknown as Record<string, unknown>,
  });

  return response as CreateLabelResponse;
}
